export const DOD_PROGRAM_PARTICIPANTS_RESET_STATE = 'DOD_PROGRAM_PARTICIPANTS_RESET_STATE';
export const DOD_PROGRAM_PARTICIPANTS_CURRENT_ITEM = 'DOD_PROGRAM_PARTICIPANTS_CURRENT_ITEM';

export const DOD_PROGRAM_PARTICIPANTS_REQUEST_LOADING = 'DOD_PROGRAM_PARTICIPANTS_REQUEST_LOADING';
export const DOD_PROGRAM_PARTICIPANTS_REQUEST_SUCCESS = 'DOD_PROGRAM_PARTICIPANTS_REQUEST_SUCCESS';
export const DOD_PROGRAM_PARTICIPANTS_REQUEST_FAILED = 'DOD_PROGRAM_PARTICIPANTS_REQUEST_FAILED';

export const DOD_PROGRAM_PARTICIPANTS_CURRENT_ACTION = 'DOD_PROGRAM_PARTICIPANTS_CURRENT_ACTION';
export const DOD_PROGRAM_PARTICIPANTS_RESET_ACTION = 'DOD_PROGRAM_PARTICIPANTS_RESET_ACTION';